import { ServicesApi } from '../apis';
import { Service, SolutionType } from '../types';

type ServiceCache = { [solutionType in SolutionType]: Service[] };

const serviceCache = {} as ServiceCache;

export const getServices = async (type?: SolutionType): Promise<Service[]> => {
  const cachedServices = serviceCache[type ?? ''];
  if (cachedServices) return cachedServices;

  const services = await ServicesApi.fetchServices(type);

  serviceCache[type ?? ''] = services;
  return services;
};
